import React, { useEffect, useState } from 'react';
import axios from "../../api/axios";
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css';
import moment from 'moment';

const AccountsSummary = () => {
    const [lifetime, setLifetime] = useState({ total_credit: 0, total_debit: 0, balance: 0 });
    const [summary, setSummary] = useState([]);
    const [startDate, setStartDate] = useState(new Date(moment().startOf('month')));
    const [endDate, setEndDate] = useState(moment().add(1, "days").format("YYYY-MM-DD"));
    const [loading, setLoading] = useState(false);

    const fetchSummary = async () => {
        setLoading(true);
        try {
            const res = await axios.get('/bank-transactions/summary', {
                params: {
                    start_date: moment(startDate).format('YYYY-MM-DD'),
                    end_date: moment(endDate).format('YYYY-MM-DD')
                }
            });
            setSummary(res.data.summary);
            setLifetime(res.data.lifetime);
        } catch (err) {
            console.error('Failed to fetch account summary:', err);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchSummary();
    }, []);

    const totalDebit = summary.reduce((sum, b) => sum + Number(b.total_debit || 0), 0);
    const totalCredit = summary.reduce((sum, b) => sum + Number(b.total_credit || 0), 0);
    const totalBalance = summary.reduce((sum, b) => sum + Number(b.balance || 0), 0);

    return (
        <div className="max-w-5xl mx-auto p-4 bg-white rounded shadow">
            <h3 className="text-md font-semibold mb-2">Lifetime Summary</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div className="bg-green-100 border border-green-300 rounded-lg p-4 shadow">
                    <h3 className="text-sm text-green-800 font-semibold">Total Credit</h3>
                    <p className="text-xl font-bold text-green-900">{Number(lifetime.total_credit).toFixed(2)} BDT</p>
                </div>

                <div className="bg-red-100 border border-red-300 rounded-lg p-4 shadow">
                    <h3 className="text-sm text-red-800 font-semibold">Total Debit</h3>
                    <p className="text-xl font-bold text-red-900">{Number(lifetime.total_debit).toFixed(2)} BDT</p>
                </div>

                <div className="bg-blue-100 border border-blue-300 rounded-lg p-4 shadow">
                    <h3 className="text-sm text-blue-800 font-semibold">Total Balance</h3>
                    <p className="text-xl font-bold text-blue-900">{Number(lifetime.balance).toFixed(2)} BDT</p>
                </div>
            </div>
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-bold">Accounts Summary</h2>
                <div className="flex items-center gap-2">
                    <Flatpickr
                        className="border px-2 py-1 text-sm rounded"
                        value={startDate}
                        onChange={date => setStartDate(date[0])}
                        options={{ dateFormat: 'Y-m-d' }}
                    />
                    <span>to</span>
                    <Flatpickr
                        className="border px-2 py-1 text-sm rounded"
                        value={endDate}
                        onChange={date => setEndDate(date[0])}
                        options={{ dateFormat: 'Y-m-d' }}
                    />
                    <button
                        className="bg-blue-600 text-white px-3 py-1 rounded text-sm"
                        onClick={fetchSummary}
                    >
                        Filter
                    </button>
                </div>
            </div>

            {loading ? (
                <p>Loading...</p>
            ) : (
                <table className="w-full border text-sm">
                    <thead className="bg-blue-800 text-white">
                        <tr>
                            <th className="border px-2 py-1 text-left">Bank Name</th>
                            <th className="border px-2 py-1 text-left">Account Number</th>
                            <th className="border px-2 py-1 text-right">Total Debit</th>
                            <th className="border px-2 py-1 text-right">Total Credit</th>
                            <th className="border px-2 py-1 text-right">Balance</th>
                        </tr>
                    </thead>
                    <tbody>
                        {summary.map((bank, i) => (
                            <tr className="odd:bg-white even:bg-gray-100" key={i}>
                                <td className="border px-2 py-1">{bank.bank_name}</td>
                                <td className="border px-2 py-1">{bank.account_number}</td>
                                <td className="border px-2 py-1 text-right">{Number(bank.total_debit).toFixed(2)}</td>
                                <td className="border px-2 py-1 text-right">{Number(bank.total_credit).toFixed(2)}</td>
                                <td className="border px-2 py-1 text-right font-semibold">{Number(bank.balance).toFixed(2)}</td>
                            </tr>
                        ))}
                        <tr className="bg-blue-100 font-bold">
                            <td className="border px-2 py-1 text-right"></td>
                            <td className="border px-2 py-1 text-right">Grand Total:</td>
                            <td className="border px-2 py-1 text-right">{totalDebit.toFixed(2)}</td>
                            <td className="border px-2 py-1 text-right">{totalCredit.toFixed(2)}</td>
                            <td className="border px-2 py-1 text-right">{totalBalance.toFixed(2)}</td>
                        </tr>
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default AccountsSummary;